/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/auto-forecast-setting-details';

export const AutoForecastSettingDetailApi = {
  findWithEntity: async (option: FindOptions) => {
    let url = `${pathname}/entity`;
    const query = serialize(option);
    url += query;
    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: UpdateAutoForecastSettingDetailBody) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateMulti: async (body: UpdateMultiAutoForecastSettingDetailBody) => {
    const url = `${pathname}/multi`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface UpdateAutoForecastSettingDetailBody {
  isSkipCondition?: boolean;
}

export interface UpdateMultiAutoForecastSettingDetailBody {
  isSkipCondition: boolean;
  autoForecastSettingDetailIDs: string[];
}

export type AutoForecastSettingDetail = {
  id: string;
  autoForecastSetting?: any;
  isSkipCondition?: boolean;
  entityProduct?: any;
  status?: number;
  createdAt?: string;
  updatedAt?: string;
};
